/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Vietnamese (Vietnam)
export default {
  'team-central.give-jira-kudos.created.description.flag': 'Bây giờ, nhóm Workplace Experience sẽ bắt tay vào thực hiện yêu cầu tặng quà này. ✨',
  'team-central.give-jira-kudos.created.title.flag': 'Đã tạo lời khen ngợi',
  'team-central.give-jira-kudos.creation.failed.description.flag': 'Chúng tôi không thể gửi quà tặng hoặc tạo lời khen ngợi của bạn. Hãy thử lập một phiếu yêu cầu riêng tại <a>go/kudos</a>.',
  'team-central.give-jira-kudos.creation.failed.title.flag': 'Đã xảy ra lỗi',
  'team-central.give-kudos.button': 'Khen ngợi',
  'team-central.give-kudos.close-button.label': 'Đóng ngăn',
  'team-central.give-kudos.confirm-close.title': 'Xác nhận đóng',
  'team-central.give-kudos.created.description.flag': 'Lời khen ngợi của bạn đã được gửi đi. <a>Xem lời khen ngợi</a>',
  'team-central.give-kudos.created.title.flag': 'Đã tạo lời khen ngợi',
  'team-central.give-kudos.creation.failed.description.flag': 'Chúng tôi không tạo được lời khen ngợi của bạn.',
  'team-central.give-kudos.creation.failed.title.flag': 'Đã xảy ra lỗi',
  'team-central.give-kudos.error-icon.label': 'Lỗi',
  'team-central.give-kudos.success-icon.label': 'Thành công',
  'team-central.give-kudos.unsaved.warning': 'Những thay đổi mà bạn đã thực hiện sẽ không được lưu.',
  'team-central.give-kudos.unsaved.warning.cancel': 'Hủy',
  'team-central.give-kudos.unsaved.warning.close': 'Đóng'
};